require('/opt/odin/app/frontend/components/modals/setup_wizard/index.module.scss');module.exports = "../../app/cells/components/modals/setup_wizard/show.erb";